module.exports = __webpack_public_path__ + "img/7.65167f6b.jpg";